package com.appcreator.compose.di

import coil3.decode.Decoder
import com.appcreator.compose.gif.GifDecoderFactor

actual fun platformGifFactory(): Decoder.Factory = GifDecoderFactor()